/* en-US locale */
export default {
  appTitle: 'Call Panel',
  localeName: 'English',
  copyright: 'All rights reserved.',
  languages: {
    'en-US': 'English (US)',
    'en-AU': 'English (AU)',
    'en-GB': 'English (GB)',
    'fr-CA': 'French (CA)'
  },
  // login page
  login: {
    title: 'Call Panel Login',
    note: 'Use username and password for login.',
    username: 'Username',
    password: 'Password',
    btn: 'Login',
    wait: 'Authentication. Please, wait...',
    error: {
      required: 'Required.',
      password: 'Invalid password.',
      username: 'Invalid username.',
      login: 'Failed login. Invalid email or password.',
      oauth2: 'Failed to authenticate with oauth2 token',
      session:
        'Invalid user session. This user is not allowed to access callpanel'
    }
  },
  // toolbar
  tb: {
    signout: 'Sign Out',
    currentUser: {
      quick_access: 'Quick access',
      language: 'Language',
      theme: 'Theme'
    },
    filter: {
      placeholder: 'Filter users list',
      hintResult: 'Filtered {num} user{plur}'
    },
    sipua: {
      sipUri: 'SIP URI',
      sipProxy: 'SIP Proxy',
      online: 'Phone is online',
      offline: 'Phone is offline'
    },
    sort: {
      title: 'Sorting parameters',
      byexten: 'By extension',
      byname: 'By name',
      dirTitle: 'Direction:',
      acs: 'ACS',
      desc: 'DESC',
      btnCancel: 'Cancel',
      btnSort: 'Sort'
    },
    cview: {
      label: 'Compact view',
      on: 'On',
      off: 'Off'
    },
    embedded: {
      btn: {
        close: 'Close'
      }
    }
  },
  rmqc: {
    online: 'Call Panel events client is online',
    offline: 'Call Panel events client connection is lost',
    error: {
      api: 'Failed to connect API: {0}',
      init: 'Failed to init events client for RabbitMQ.',
      connLost: 'Connection to Events System is lost.'
    }
  },
  // buddy card
  buddy: {
    searchPlaceholder: 'Search a buddy by extension, name or department',
    draggable: 'Draggable',
    sort: {
      title: 'Sort',
      custom: 'Custom',
      byExtension: 'By Extension',
      byName: 'By Name',
      byStatus: 'By Status'
    },
    tooltip: {
      vm: 'Voice Mail messages.',
      listen: 'Listen current active call.',
      sipcall: 'Call User',
      unwatch: 'Remove card from dashboard.',
      watch: 'Append to buddies list.',
      unpark: 'Retrieve parked call',
      dndOver: 'Drop to transfer call {call} to {to}',
      startChat: 'Start a chat with that user'
    },
    calltime: {
      from: 'From',
      to: 'To'
    },
    bargein: {
      title: 'Call barge-in options',
      cancel: 'Cancel',
      start: 'Start',
      monitor: 'Monitor call',
      fullBarge: 'Full barge-in',
      whisper: 'Whisper on {0}'
    },
    status: {
      online: 'User is online.',
      offline: 'User is offline.',
      calling: 'Calling...',
      busy: 'User is busy.',
      away: 'User is away.',
      oncall: 'User is on call.',
      ringing: 'Phone is ringing',
      onlunch: 'Out to lunch',
      unknown: 'User status is unknown.',
      sms: 'This user is a SMS.'
    },
    prefs: {
      dndOn: 'Do Not Disturb is On',
      dndOff: 'Do Not Disturb is Off',
      fwdOn: 'Call forward is enabled',
      fwdOff: 'Call forward is disabled',
      fmeOn: 'Follow-Me is enabled',
      fmeOff: 'Follow-Me is disabled'
    },
    card: {
      dept: 'Dept',
      dropZone: 'Drop here'
    },
    jambotron: {
      title: 'Call panel.',
      note: 'Users to watch can be set by adding departments in user account.'
    }
  },
  // loading dialog
  loading: {
    statusDefault: 'Loading. Please stand by...',
    dataInit: 'Loading data...'
  },
  // Users left navigation panel
  users: {
    menuTitle: 'Users',
    displayOptions: 'Display Options'
  },
  userPictureProfiles: {
    title: 'Profile Picture(s)',
    emptyPlaceholder: 'Your profile pictures will be here. You will be able to see your uploaded picture and your Google picture if you sign in with a Google account.',
    reloadRequired: 'A page reload is required in order to see the new picture.',
    pictureTypes: {
      gmail: 'Google',
      uploaded: 'Uploaded'
    },
    fileField: {
      label: 'Upload a new profile picture',
      placeholder: 'Pick a picture'
    },
    crop: {
      title: 'Crop tool'
    },
    errors: {
      unvalidateImage: 'Please select an image file',
      unsupportedFileReader: 'Sorry, FileReader API not supported'
    },
    btn: {
      cancel: 'Cancel',
      close: 'Close',
      crop: 'Crop',
      noCrop: 'Do not Crop'
    }
  },
  chat: {
    menuTitle: 'Chat',
    navTitle: 'Chat',
    openMenu: 'Open Menu',
    as: 'As',
    closed: 'Closed',
    filterClosed: 'Filter closed conversations',
    filterRead: 'Filter read conversations',
    youu: 'you',
    typing: 'typing...',
    from: 'From',
    publicChannels: 'Public Channels',
    privateChannels: 'Private Channels',
    publicChannel: 'Public Channel',
    privateChannel: 'Private Channel',
    directMessages: 'Direct Messages',
    openChat: 'Open Chat',
    roomType: {
      c: 'Public',
      p: 'Private',
      d: 'Direct Conversation'
    },
    search: 'Search a conversation',
    conversation: 'no conversation | 1 conversation | {count} conversations',
    messageOverlay: {
      notJoined: 'You have not joined the room <b>{roomName}</b> yet.',
      archived: 'The room <b>{roomName}</b> is archived.'
    },
    advancedChat: {
      ROOMS_EMPTY: 'No conversation',
      ROOM_EMPTY: 'No conversation selected',
      NEW_MESSAGES: 'New messages',
      MESSAGE_DELETED: 'This message has been deleted',
      MESSAGES_EMPTY: 'No messages',
      CONVERSATION_STARTED: 'Conversation started on:',
      TYPE_MESSAGE: 'Type your message',
      SEARCH: 'Search',
      IS_ONLINE: 'is online',
      LAST_SEEN: 'last seen',
      IS_TYPING: 'is typing...',
      CANCEL_SELECT_MESSAGE: 'Cancel Selection'
    },
    roomActions: {
      replyMessage: 'Reply',
      editMessage: 'Edit',
      deleteMessage: 'Delete'
    },
    date: {
      now: 'now',
      year: '1 year ago | {count} years ago',
      month: '1 month ago | {count} months ago',
      day: '1 day ago | {count} days ago',
      week: '1 week ago | {count} weeks ago',
      hour: '1 hour ago | {count} hours ago',
      minute: '1 minute ago | {count} minutes ago',
      seconds: '1 second ago | {count} seconds ago'
    },
    // conversation context menu
    contextMenu: {
      open: 'open',
      close: 'close',
      leave: 'leave',
      join: 'join',
      archive: 'archive',
      restore: 'restore',
      see_members: 'see members',
      manage_members: 'manage members',
      see_files: 'see files',
      delete: 'delete',
      invite: 'invite',
      kick: 'kick',
      add_owner: 'add owner',
      remove_owner: 'remove owner',
      rename: 'rename',
      search_messages: 'Search Messages',
      add_shared_contact: 'Add To Shared Contacts',
      add_personal_contact: 'Add To Personal Contacts',
      see_contact: 'See Contact',
      add_blacklist: 'Add To Blacklist'
    },
    smsSettings: 'SMS Settings',
    // global sms context menu
    smsContextMenu: {
      title: 'SMS List',
      filterMySmsDid: 'Filter with my numbers',
      filterSortBy: 'Sort By',
      properties: {
        recent_activity: 'Recent Activity',
        alphabetically: 'Alphabetically'
      }
    },
    smsToEmails: {
      title: 'SMS to Emails',
      email: 'Email',
      enabled: 'Enabled',
      phoneNumber: 'Phone Number',
      save: 'Save',
      reset: 'Reset',
      notify: {
        saved: 'SMS-to-email configurations are saved successfully'
      },
      errors: {
        emailRequired: 'Email is required',
        emailInvalid: 'Email is invalid',
        phoneNumberRequired: 'Phone Number is required'
      }
    },
    // global DM context menu
    dmContextMenu: {
      title: 'DM List',
      filterSortBy: 'Sort By',
      properties: {
        recent_activity: 'Recent Activity',
        alphabetically: 'Alphabetically'
      }
    },
    // global channels context menu
    channelsContextMenu: {
      title: 'Public Channels List',
      filterSortBy: 'Sort By',
      properties: {
        recent_activity: 'Recent Activity',
        alphabetically: 'Alphabetically'
      }
    },
    // global channels context menu
    groupsContextMenu: {
      title: 'Private Channels List',
      filterSortBy: 'Sort By',
      properties: {
        recent_activity: 'Recent Activity',
        alphabetically: 'Alphabetically'
      }
    },
    newConversation: {
      title: 'New message',
      users: 'User(s)',
      message: 'Message',
      uploadFiles: 'Upload Files',
      phoneNumber: 'Phone Number',
      fromDID: 'From DID',
      conversationType: 'Conversation Type',
      channelType: 'Channel Type',
      private: 'Private',
      public: 'Public',
      channelName: 'Channel Name',
      pickEmojis: 'Pick Emojis',
      errors: {
        specialCharacters:
          "This field cannot contain special characters and will be replaced by '-'.",
        fieldRequired: 'This field is required',
        fieldRequiredAndUniq: 'This field is required and should be uniq'
      },
      btn: {
        cancel: 'Cancel',
        submit: 'Send'
      }
    },
    members: {
      title: 'Members in',
      owner: 'Owner',
      member: 'Member',
      btn: {
        close: 'Close'
      }
    },
    availableUsers: {
      title: 'Available Users',
      selected: 'Selected',
      member: 'Member',
      btn: {
        cancel: 'Cancel',
        submit: 'Add'
      }
    },
    renameChannel: {
      title: 'Rename',
      btn: {
        cancel: 'Cancel',
        submit: 'Rename'
      }
    },
    confirmDialog: {
      title: '{channelAction} this channel?',
      message:
        'Are you sur you want to {channelAction} the channel <span class="{textColor}">{channelName}</span>?',
      member: {
        message: {
          add_owner:
            'Are you sur you want to make <span class="{textColor}">{memberName}</span> an owner of the channel <span class="{textColor}">{channelName}</span>?',
          remove_owner:
            'Are you sur you want to remove ownership from <span class="{textColor}">{memberName}</span> for the channel <span class="{textColor}">{channelName}</span>?',
          kick:
            'Are you sur you want to remove <span class="{textColor}">{memberName}</span> from the channel <span class="{textColor}">{channelName}</span>?'
        }
      },
      btn: {
        cancel: 'Cancel'
      }
    },
    closeDm: {
      title: 'Close this direct chat?',
      message:
        'This will hide this chat from the left menu but it will reopen as soon as you receive a new message, are you sure you want to proceed?',
      btn: {
        cancel: 'Cancel',
        submit: 'Close'
      }
    },
    presence: {
      online: 'online',
      offline: 'offline',
      away: 'away',
      busy: 'busy',
      unknown: 'unknown'
    }
  },
  unsupported: {
    title: 'Browser not supported',
    note:
      'Sorry, your browser is too old or not compatible with the application.',
    help:
      'Please, upgrade your browser, try different browser or contact technical support.'
  },
  // SIP UA dialog box
  sipua: {
    title: 'Call',
    box: {
      title: 'Realtime call listening',
      dialfield: 'Number to dial',
      btnhup: 'Hanup and close',
      callFrom: 'From',
      callTo: 'To'
    },
    error: {
      listenFail: 'Failed to listen the call. SIP UA is not connected.',
      callFail: 'Call failed',
      maxCallsOut:
        'Max calls limit reached. Can not have more then {limit} calls.',
      maxCallsIn:
        'Max {limit} calls allowed. Call from "{fromName}" <{fromNum}> is rejected.',
      notSupported:
        'Web Call are disabled because your browser does not support WebRTC. ' +
        'Please update your browser or review your browser settings.',
      recDisabled: 'Recording is disabled',
      invalidNumber: 'Invalid number',
      invalidFeatureCode: 'Invalid feature code'
    },
    hint: {
      ready: 'Ready to call',
      calling: 'Calling {to}...',
      oncall: 'On call with {num}',
      missNum: 'Enter a number to call',
      notReady: 'SIP UA client is not ready',
      incall: 'Incoming call...'
    },
    notify: {
      title: 'New incoming call',
      body: 'Call from "{name}" <{num}>'
    },
    menu: {
      accept: 'Accept',
      reject: 'Reject',
      hangup: 'Hangup',
      dialpad: 'Dial pad',
      volume: 'Volume',
      parking: 'Park call',
      mute: 'Mute',
      unmute: 'Unmute',
      hold: 'Hold',
      unhold: 'UnHold',
      conf3w: '3-Way Conference',
      label3wc: 'Invite number',
      xfer: 'Transfer',
      vmail: 'Voice Mail',
      callsLog: 'History',
      recStart: 'Start recording this call',
      recStop: 'Stop recording this call'
    },
    xfer: {
      title: 'Transfer call to',
      title2: 'Transfer call',
      label: 'Transfer call to',
      placeholder: 'Phone number',
      confirm: 'Confirm',
      cancel: 'Cancel',
      init: 'Transfer to {num} initiated...',
      success: 'Successfully transferred the call to {num}',
      park: 'Call is successfully sent to parking lot',
      failed: 'Failed to transfer the call to {num}: {fail}'
    }
  },
  // Stats right navigation panel
  stats: {
    title: {
      nav: 'Stats',
      calls: 'Last hour calls',
      usersTotal: 'Total users',
      onlineStatus: 'Online / Offline',
      onCall: 'On Call'
    },
    cdrApiFail: 'Failed to load call history via API'
  },
  // queues page
  queues: {
    menuTitle: 'Queues',
    agentsTitle: 'Agents',
    callsTitle: 'Calls',
    dashboard: 'Dashboard',
    calls: {
      noCalls: 'No active calls in the queue'
    },
    agent: {
      ignoreBusy: 'Ignore Busy.',
      ringInUse: 'Ring in use.',
      callsTaken: 'Calls taken',
      respDelay: 'Response delay',
      callerCall: 'Caller on call with the agent.',
      chanspy: 'Listen to current call with web phone (chan spy)'
    },
    redirect: {
      title: 'Pickup or redirect call in the queue',
      subtitle: 'Call from: {name} <{num}>',
      lblPickup: 'Pickup this call',
      lblRedirect: 'Redirect call',
      lblDest: 'Redirect destination',
      lblPlacehdr: 'Start typing name or extension',
      btnCancel: 'Cancel',
      btnPickup: 'Pickup',
      btnRedir: 'Redirect',
      destError: 'Destination is required',
      successRedir: 'Call from {from} is redirected to {to}',
      pickupReqSent: 'Pickup call request is sent'
    },
    tooltip: {
      watch: 'Add to dashboard.',
      listCalls: 'Calls in queue',
      allPause: 'Pause all agents',
      allUnpause: 'Unpause all agents',
      agents: 'Agents and calls details',
      hide: 'Hide',
      pause: 'Click to pause the agent',
      unpause: 'Click to unpause the agent',
      pauseNoPerm: 'Agent pause option is not permitted',
      inCalls: 'Number of calls in the queue',
      agentsOnCall: 'Number of agents on call',
      redirect: 'Pickup or redirect call'
    },
    jumbotron: {
      watchHint: 'Add queues to watch.',
      title: 'Call Queues',
      note: 'Call queues configured with your account.'
    },
    body: {
      agents: 'Agents',
      agentsPaused: 'Agents paused',
      agentsOnCall: 'Agents on call',
      calls: 'Calls in queue',
      holdtime: 'Avg. hold time',
      completed: 'Completed calls',
      abandoned: 'Abandoned calls'
    },
    stats: {
      oncall: 'On call callers',
      waiting: 'Waiting callers',
      completed: 'Completed calls',
      abandoned: 'Abandoned calls',
      agentsTotal: 'Total Agents',
      agentsPaused: 'Paused',
      agentsUnpaused: 'Unpaused'
    },
    pauseDlg: {
      pauseAgent: 'Pause agent',
      unpauseAgent: 'Unpause agent',
      pauseAll: 'Pause all agents',
      unpauseAll: 'Unpause all agents',
      allAgents: 'All agents',
      enableCause: 'Set a custom status',
      hint: 'Total available pause status',
      label: 'Pause status',
      confirm: 'Confirm',
      cancel: 'Cancel',
      pauseCodes: {
        // use snake case for dynamic use from API
        lunch_break: 'Lunch break',
        break: 'Break',
        wrap_up_time: 'Wrap up time',
        meeting: 'Meeting',
        clock_out: 'Clock Out'
      }
    },
    reports: {
      title: 'Reports',
      tooltip: 'Open queue reports',
      loading: 'Loading report data',
      loadFail: 'Failed to load report data',
      unknownReportType: 'Unknown report type',
      noreport: '<strong>Nothing here yet!</strong><br />Choose your filters above to run a report.',
      none: 'None',
      filters: {
        showFilters: 'Show Filters',
        hideFilters: 'Hide Filters',
        title: 'Queue Reports Filters',
        reportType: 'Report type',
        queue: 'Queue(s)',
        plusMoreQueues: '(+{count} more)',
        agent: 'Agent',
        startDate: 'Start date',
        endDate: 'End date',
        timezone: 'Time Zone',
        scope: 'Time Frame',
        month: 'Month',
        week: 'Week',
        day: 'Day',
        submit: 'Run'
      },
      reportTypes: {
        queueSummary: 'Queue Summary',
        callDetails: 'Call Details',
        agentDetails: 'Agent Details'
      },
      scopeOptions: {
        day: 'Day',
        week: 'Week',
        month: 'Month',
        custom: 'Custom'
      },
      scopeDisplays: {
        range: '<strong>{start}</strong> to <strong>{end}</strong>',
        hour: '<strong>{date}</strong> from <strong>{start}</strong> to <strong>{end}</strong>'
      },
      queueSummary: {
        title: 'Queue Summary Report',
        queueTitle: 'Queue Totals',
        dateTitle: 'Timeframe',
        agentTitle: 'Agents',
        table: {
          queuename: 'Queue Name',
          date: 'Date',
          calls: 'Calls',
          answered: 'Answered',
          abandon: 'Abandoned',
          timeout: 'Timeout',
          exit: 'Exit',
          avgHold: 'Avg Hold',
          avgTalk: 'Avg Talk',
          maxTalk: 'Max Talk',
          totalTalk: 'Total',
          total: 'Total'
        },
        chart: {
          failedLoad: 'Chart could not be loaded',
          exited: 'Exited',
          timeout: 'Timeout',
          abandoned: 'Abandoned',
          answered: 'Answered'
        }
      },
      agent: {
        title: 'Queue Agent Details',
        summary: {
          agent: 'Agent',
          offered: 'Offered',
          answered: 'Answered',
          minTime: 'Min Time',
          avgTime: 'Avg Time',
          maxTime: 'Max Time',
          totalTime: 'Total',
          total: 'Total'
        },
        details: {
          time: 'Date/Time',
          event: 'Event',
          callerId: 'Caller',
          queue: 'Queue',
          holdTime: 'Hold Time',
          duration: 'Duration'
        }
      },
      callDetails: {
        title: 'Queue Call Details',
        table: {
          dateTime: 'Date/Time',
          queue: 'Queue',
          callerId: 'Caller',
          callStatus: 'Status',
          agents: 'Agent',
          holdTime: 'Hold Time',
          callDuration: 'Duration',
          total: 'Total'
        },
        details: {
          title: 'Call Events',
          loading: 'Loading events details per call',
          loadFail: 'Failed to load events details per call',
          table: {
            time: 'Time',
            queue: 'Queue',
            callerId: 'Caller',
            event: 'Event',
            agent: 'Agent',
            wait: 'Wait',
            duration: 'Duration'
          }
        },
        statuses: {
          notMapped: 'N/A',
          ABANDON: 'Abandoned',
          COMPLETEAGENT: 'Answered',
          COMPLETECALLER: 'Answered',
          CONNECT: 'Connected',
          EXITEMPTY: 'Exit Empty',
          EXITWITHKEY: 'Keypress',
          EXITWITHTIMEOUT: 'Timeout',
          inQue: 'In Queue'
        }
      },
      eventDetails: {
        events: {
          notMapped: 'N/A',
          ABANDON: 'Abandoned',
          ADDMEMBER: 'Add member',
          COMPLETEAGENT: 'Agent Completed',
          COMPLETECALLER: 'Caller Completed',
          CONFIGRELOAD: 'Reload config',
          CONNECT: 'Connected',
          ENTERQUEUE: 'Enter Queue',
          EXITEMPTY: 'Exit Empty',
          EXITWITHKEY: 'Exit with key',
          EXITWITHTIMEOUT: 'Exit with timeout',
          PAUSE: 'Pause',
          PAUSED: 'Paused',
          QUEUESTART: 'Queue Start',
          REMOVEMEMBER: 'Remove member',
          RINGCANCELED: 'Ring Canceled',
          RINGNOANSWER: 'Ring No Answer',
          UNPAUSE: 'Unpause',
          UNPAUSED: 'Unpaused',
          AGENTLOGIN: 'Agent Unpaused',
          AGENTLOGOFF: 'Agent Paused',
          ATTENDEDTRANSFER: 'Attended Transfer',
          BLINDTRANSFER: 'Blind Transfer',
          AGENTDUMP: 'Agent Dump',
          SYSCOMPAT: 'SysCompat',
          PAUSEALL: 'Pause All',
          UNPAUSEALL: 'Unpause All',
          PENALTY: 'Penalty',
          RINGINUSE: 'Ring in use',
          WITHDRAW: 'Withdraw',
          OUTCALL: 'Out Call'
        }
      }
    }
  },
  availableExtensions: {
    title: 'Available Extensions',
    extension: 'Extension',
    usernameToSearch: 'Search an available extension'
  },
  videoconf: {
    menuTitle: 'Video Conferences',
    emptyTitle: 'Choose Video Conference',
    emptyText: "You don't have a video conference yet.",
    loading: 'Joining video conference "{room}"',
    rejoin: 'Re-connecting video conference "{room}"',
    disconnect: 'Disconnected from "{room}" video conference',
    filters: 'Dynamics Conferences Filter',
    extension: 'Extension {extension}',
    btn: {
      create: 'Create Video Conference'
    },
    participantsDialog: {
      btn: {
        close: 'Close'
      },
      title: 'Members in <b>{name}</b>',
      admin: 'Admin',
      member: 'Member'
    },
    aboutDialog: {
      btn: {
        close: 'Close'
      },
      title: 'About <b>{name}</b>'
    },
    deleteDialog: {
      btn: {
        delete: 'Delete',
        cancel: 'Cancel'
      },
      title: 'Delete a video conference',
      message:
        'Are you sure you want to delete the video conference <b>{name}?</b>'
    },
    optionsContextMenu: {
      update: 'Update',
      delete: 'Delete',
      about: 'About this meeting',
      seeParticipants: 'See Participants'
    },
    form: {
      update: 'Update',
      create: 'Create',
      cancel: 'Cancel',
      required: 'Required',
      invalidName: 'Invalid name',
      pick: 'Pick',
      general: 'General',
      shareScreen: 'Share Screen',
      recording: 'Recording',
      telephony: 'Telephony',
      emptyAdminPlaceholder: 'Leave empty for no admin',
      emptyUserPlaceholder: 'Leave empty to include all users',
      prompt: 'To join the conference over the phone',
      fields: {
        name: 'Name',
        expireAt: 'Expires on',
        admins: 'Admins',
        users: 'Users',
        roomNumber: 'ID',
        roomPin: 'PIN',
        enableForAdmin: 'Enabled for admin(s)',
        enableForGuest: 'Enabled for guest(s)',
        callerIdName: 'Caller ID Name',
        callerIdNumber: 'Caller ID Number',
        username: 'Extension',
        validations: {
          expireAt: {
            required: 'Expire at date is required',
            min: 'Expire at minimum date must be {date}'
          }
        }
      }
    },
    tooltip: {
      admin: 'You are an administrator of this conference',
      excludeDynamic: 'Filter dynamic video conferences',
      includeDynamic: 'Do not filter dynamic video conferences',
      expireAt: 'Conference expire time',
      expired: 'Conference is expired',
      join: 'Join video conference "{name}"',
      openNew: 'Open in a new browser tab',
      hangup: 'Hangup',
      minimize: 'Minimize',
      expand: 'Detach',
      fullscreen: 'Fullscreen',
      copyGuestLink: 'Copy the guest URL to clipboard',
      small: 'Dock',
      license:
        'Total conference(s): {total}, License: {license}, Allowed on the system: {global}',
      unlimited: 'Unlimited'
    },
    info: {
      title: 'About this meeting',
      info: 'Information',
      value: 'Value',
      items: {
        participant_in_meeting: 'User(s) in the meeting',
        users_count: 'Users',
        guest_url: 'URL of the conference',
        expireAt: 'Expires',
        phone_numbers: 'Phone number(s)',
        admins_count: 'Administrator(s)',
        extension: 'Extension',
        sharedScreenAdmin: 'Screen share enabled for admin(s)',
        sharedScreenGuest: 'Screen share enabled for guest(s)',
        recordingAdmin: 'Recording enabled for admin(s)',
        recordingGuest: 'Recording enabled for guest(s)',
        roomNumber: 'ID to join the conference over the phone',
        roomPin: 'PIN to join the conference over the phone',
        enabled: {
          true: 'Enabled',
          false: 'Disabled'
        }
      }
    },
    users: {
      title: 'Users',
      name: 'Name',
      status: 'Status',
      online: 'In Meeting',
      offline: 'Offline'
    },
    msg: {
      joined: 'Video conference joined',
      left: 'You left the video conference',
      connecting: 'Connecting...',
      copy: {
        success: 'Successfully copied',
        error: 'An error has occurred while copying'
      }
    }
  },
  // conferences page
  confr: {
    menuTitle: 'Conferences',
    capacity: 'Capacity',
    members: 'Members',
    pin: 'User PIN',
    adminpin: 'Admin PIN',
    exten: 'Dial exten',
    kick: 'Kick the conference user',
    mute: 'Toggle user mute',
    personal: {
      title: {
        card: 'Your personal conference',
        form: 'Personal conference settings',
        data: 'My personal conference',
        opt: 'Options'
      },
      disabledTooltip: 'Personal conference is disabled. ' +
        'You can enable it in conference setting.',
      settings: {
        saveOk: 'Personal conference settings successfully saved',
        btnTooltip: 'Edit personal conference settings',
        btn: {
          save: 'Save',
          cancel: 'Cancel'
        },
        label: {
          activate: 'Activate my personal conference',
          userPin: 'User PIN',
          maxUsers: 'Maximum participants (including Admin)',
          countSay: 'Announce user count',
          moh: 'Music on hold',
          waitAdmin: "Wait for the Admin's arrival to start",
          joinSay: 'Announce user join/leave',
          openMenu: 'Open the options menu by pressing "*"',
          listenOnly: 'Listen only mode (users)'
        },
        error: {
          invalPIN: 'PIN is required and must have numeric values only',
          maxUsersNum: 'Max users number value must be numeric value',
          maxUsersInval: 'Value must be 0 or more. 0 for unlimited',
          noPerm:
            'User does not have permission to update personal conference settings'
        }
      }
    },
    inv: { // invite into conference
      title: 'Invite into the conference',
      label: 'Number to invite',
      invalid: 'Number to dial is invalid',
      cancel: 'Cancel',
      invite: 'Invite'
    },
    kickDlg: {
      title: 'Confirm user kick',
      msg: 'Kick user <{num}> "{name}" from conference "{conf}"?',
      ok: 'Yes',
      cancel: 'Cancel'
    },
    tooltip: {
      watch: 'Add to dashboard.',
      btnCall: 'Call the conference',
      btnMems: 'Show the active conference members',
      btnNoMember: 'No members are currently in the conference',
      invite: 'Invite into the conference',
      isInvited: 'This member is invited',
      isAdmin: 'Conference administator',
      dndOver: 'Transfer the call to conference {name}',
      close: 'Close'
    },
    jumbotron: {
      title: 'Conferences',
      note: 'List of active conferences.'
    }
  },
  // parking page
  parking: {
    menuTitle: 'Parking',
    freeSlot: 'Free Slot',
    dropToPark: 'Drop to park',
    directPark: 'Park call to parking slot <{slot}>',
    jumbotron: {
      title: 'Parked calls',
      note: 'List of parked calls when there are any'
    },
    label: {
      parkedBy: 'Parked By',
      parkedCall: 'Parked Call',
      parkedAt: 'Parked At'
    },
    tooltip: {
      space: 'Call is parked on parking space',
      retrieveCall: 'Retrieve call parked on '
    }
  },
  // voicemail page
  vmail: {
    menuTitle: 'Voicemails',
    vmbSelectBoxesLabel: 'voicemail boxes',
    loading: 'Loading Voicemails',
    searchPlaceholder: 'Search Voicemails',
    filters: 'Filters',
    vmb: 'Voicemail Box',
    forceTranscriptionEnableDialog: {
      title: 'Transcription Disabled',
      text: 'Your message will not be summarized or transcribed',
      buttons: {
        enable: 'Enable',
        later: 'Later',
        never: 'Never'
      }
    },
    detail: {
      pages: '{0} of {1}',
      errors: {
        noVoicemailFound: 'No Voicemails found'
      }
    },
    moveToCustomFolder: {
      title: 'Move to Custom Folder',
      bulkTitle: 'Move Voicemails to Custom Folder',
      bulkIntro: 'Move {count} voicemails to a custom folder',
      folderLabel: 'Select or create a new folder',
      folderPlaceholder: 'Select or create a new folder',
      btnCancel: 'Cancel',
      btnMoveToCustomFolder: 'Move',
      errors: {
        folderNameRequired: 'Folder name is required',
        invalidFolderName: 'Only letters allowed (3-10 characters)',
        reservedFolderName: 'This is a reserved folder name and is not allowed.'
      }
    },
    tip: {
      noData: 'No Voicemail Found',
      noSummary: '(Summary unavailable)',
      refreshVm: 'Refresh the voicemail list',
      addToFavorites: 'Add to favorites',
      removeFromFavorites: 'Remove from favorites',
      markRead: 'Mark as Read',
      markUnread: 'Mark as Unread',
      deleteVoicemail: 'Delete Voicemail',
      forwardVoicemail: 'Forward Voicemail',
      toggleReadUnread: 'Toggle Read / Unread'
    },
    footerProps: {
      pageText: '{0}-{1} of {2}',
      perPage: 'Per page'
    },
    jumbotron: {
      title: 'Voicemails',
      note: "List of user's voicemail messages."
    },
    title: {
      vmNew: 'New messages',
      vmOld: 'Old messages',
      transcription: 'Transcription',
      summary: 'Summary',
      translation: 'Translation'
    },
    btn: {
      editGreetAudio: 'Edit Audio',
      play: 'Play',
      del: 'Delete',
      markRead: 'Mark as read',
      markUnread: 'Mark as unread',
      removeFromFavorites: 'Remove from favorites',
      addToFavorites: 'Add to favorites',
      call: 'Call back',
      nocall: 'Ivalid call back number',
      xfer: 'Transfer',
      readAsText: 'Read as text',
      bulk: '{count} selected',
      favorite: 'Mark as favorite',
      unfavorite: 'Unmark as favorite',
      displayOrigTranscription: 'Display Original Transcription',
      moveToCustomFolder: 'Move to custom folder',
      removeFromCustomFolder: 'Remove from custom folder',
      goBack: 'Go back'
    },
    myvms: 'My voicemails',
    categories: {
      all: 'All',
      solicitation: 'Solicitation',
      political: 'Political',
      personal: 'Personal',
      medical: 'Medical',
      fraud: 'Fraud',
      emergency: 'Emergency',
      travel: 'Travel',
      misc: 'Misc'
    },
    listToolbar: {
      labels: {
        folder: 'Folder',
        category: 'Category',
        search: 'Search',
        dateLabel: 'Filter by date',
        datePlaceholder: 'Pick a date'
      }
    },
    hdrs: {
      menu: 'Menu',
      folder: 'Folder',
      category: 'Category',
      play: 'Play',
      time: 'Call time',
      cidName: 'Caller Name',
      cidNum: 'Caller Number',
      duration: 'Message duration',
      readAsText: 'Read As Text',
      transcriptionCategory: 'Category',
      summary: 'Summary'
    },
    help: {
      readAsText: 'Read the text version of this voicemail'
    },
    folder: {
      all: 'All',
      inbox: 'Inbox',
      old: 'Old',
      favorite: 'Favorite'
    },
    cfg: {
      btnSave: 'Save',
      filter: {
        tab: 'Filter',
        selectBox: 'Select voicemail box',
        selectBoxes: 'Select voicemail boxes',
        dateLabel: 'Select date'
      },
      settings: {
        tab: 'Settings',
        email: 'Email Address',
        pager: 'Pager Email Address / SMS Number',
        pin: 'Voicemail Pin',
        attach: 'Attach Message to Email Notification',
        delvm: 'Do Not Store Voicemail',
        playcid: 'Play CID (when dialing in)',
        envelope: 'Play Envelope (when dialing in)',
        skipInstruct: 'Skip VM instructions',
        transcript: 'Enable transcription',
        summarize: 'Enable summary',
        categorize: 'Enable category',
        translate: 'Enable translation'
      },
      greeting: {
        tab: 'Greetings',
        name: 'Name Greeting',
        busy: 'Busy Greeting',
        unavail: 'Unavailable Greeting',
        temp: 'Temporary Greeting',
        recdur: 'Recording duration',
        rectime: 'Recording create date and time',
        defaults: 'PBX Defaults',
        btnReset: 'Reset',
        btnRestore: 'Restore',
        btnUpload: 'Upload',
        btnTTS: 'Text',
        btnRecord: 'Record',
        btnCancel: 'Cancel',
        btnClose: 'Close',
        btnSave: 'Save',
        updated: 'Updated "{name}"',
        confirmTitle: 'Reset recording?',
        confirmMsg:
          'This will remove custom recording "<strong>{name}</strong>"' +
          ' and reset to PBX defaults.',
        archive: {
          title: 'Restore from archive',
          subtitle: 'Replace "{name}" message',
          label: 'Archive before reset',
          name: 'Archive name',
          btnRestore: 'Restore',
          nameRequired: 'Archive name required',
          ttStop: 'Stop playing',
          ttPlay: 'Play archived recording',
          success: 'Archive is successfully restored'
        },
        rec: {
          title: 'Recording "{name}"',
          failMediaTitle: 'Media not found',
          failMediaMsg:
            'Failed to detect media capabilities. Please, check your ' +
            'microphone and reload the page or restart your browser.',
          failMediaPermission: 'Microphone usage has been denied.'
        },
        upload: {
          title: 'Upload "{name}"',
          label: 'WAV file to upload'
        },
        tts: {
          title: 'Text To Speech',
          cancel: 'Cancel',
          save: 'Save'
        },
        notify: {
          archived: 'Greeting is successfully archived.',
          reset: 'Greeting is reset successfully.'
        },
        default: {
          name: '{name}',
          busy: 'You have reached the mailbox of {name}, who is on another call at this time. Please leave a message after the tone.',
          unavailable: 'You have reached the mailbox of {name}. Please leave a message after the tone.',
          temp: 'You have reached the mailbox of {name}. Please leave a message after the tone.'
        }
      },
      err: {
        email: 'Invalid email',
        pager: 'Invalid email / SMS number',
        pin: 'Invalid PIN. Numbers only',
        pinln: 'Invalid PIN. From {min} to {max} numbers only',
        uploadType: 'Invalid file type. Only WAV files allowed.',
        uploadSize: 'Max file size is 2Mb',
        valueNotGreaterThan: 'Value must be greater than {value}.'
      }
    },
    xfer: {
      title: 'Transfer voicemail message',
      destinationLabel: 'Transfer destination',
      destinationPlaceholder: 'Name or extension...',
      bulkTitle: 'Transfer voicemail messages',
      bulkIntro: 'Transfer <strong>{count}</strong> voicemail messages to destination:',
      btnCancel: 'Cancel',
      btnXfer: 'Transfer'
    },
    del: {
      title: 'Confirm Delete',
      bulkTitle: 'Confirm Delete',
      bulkConfirm: 'This action will remove <strong>{count}</strong> voicemail messages?',
      btnCancel: 'Cancel',
      btnDel: 'Delete'
    },
    notify: {
      savedOk: 'Voicemail settings are saved',
      saveFail: 'Failed to update voicemail settings',
      xferOk: 'Voicemail message "{callerid}" is transferred to {to}',
      bulkMarkReadOk: 'Marked {count} voicemail messages as read',
      bulkMarkUnreadOk: 'Marked {count} voicemail messages as unread',
      bulkXferOk: 'Transferred {count} voicemail messages to {to}',
      bulkDelOk: 'Deleted {count} voicemail messages',
      hasMultipleWatchers: 'Multiple mailboxes selected',
      noReadPerms: 'No permissions to see voicemail box settings'
    }
  },
  // announcements
  announce: {
    menuTitle: 'Announcements',
    emptyPlaceholder: 'Your announcement audio files will be here.',
    searchPlaceholder: 'Search Announcements',
    loading: 'Load Announcements',
    tip: {
      noData: 'No announcement found'
    },
    columns: {
      name: 'Name',
      pin: 'Pin',
      voiceType: 'Voice Type',
      voiceCategory: 'Voice Category',
      voiceLanguage: 'Voice Language',
      formattedPostDest: 'Post Destination',
      lang: 'Post Destination Language',
      textToSpeech: 'Text To Speech',
      pitch: 'TTS Pitch',
      speed: 'TTS Speed',
      volumeGainDb: 'TTS Volume Gain',
      ttsLanguage: 'TTS Language',
      textType: 'TTS Type',
      actions: 'Actions'
    },
    footerProps: {
      pageText: '{0}-{1} of {2} announcements',
      total: 'Announcements per page'
    },
    edit: {
      title: 'Update announcement',
      name: 'Name',
      pin: 'PIN',
      lang: 'Language',
      required: 'Required field',
      requiredForTTS: 'Required field for TTS',
      numeric: 'Must be numeric value',
      t2s: 'Text to generate the announcement',
      cancel: 'Cancel',
      update: 'Update'
    },
    tts: {
      buildBtn: 'Build and listen'
    },
    upload: {
      title: 'Upload announcement file',
      file: 'Upload file',
      hint: 'Select local wav or mp3 file to upload',
      required: 'Required wav or mp3 file to upload',
      cancel: 'Cancel',
      btnUpload: 'Upload'
    },
    columnRenderer: {
      yes: 'Yes',
      no: 'No',
      copy: 'Copy',
      copied: 'Copied',
      voiceCategories: {
        standard: 'Basic',
        news: 'News',
        wavenet: 'WaveNet',
        polyglot: 'Polyglot',
        chirpHD: 'Chirp HD',
        chirp3HD: 'Chirp3 HD',
        studio: 'Studio',
        neural2: 'Neural2'
      },
      channelTypes: {
        text: 'Plain Text',
        ssml: 'SSML'
      }
    },
    recording: 'Record',
    ttip: {
      upload: 'Upload announcement audio file',
      record: 'Record announcement',
      reset: 'Reset recording'
    },
    tabRec: 'Recording',
    tabT2S: 'Text-to-Speech',
    loadError: 'Failed to get announcement recording stream',
    noWritePerm: 'You do not have permissions to update announcement. ' +
      'Please, contact technical support for more details'
  },
  contacts: {
    menuTitle: 'Contacts',
    featureCode: 'Feature Code',
    featureCodes: {
      vm: 'Voicemail Boxes',
      myvm: 'My Voicemail Box',
      recording: 'New Announcement',
      echo: 'Echo',
      anonymouscall: 'Anonymous Call',
      leave_voicemail: 'Leave a voicemail',
      chan_spy: 'Chan Spy',
      timecondition_switch: 'Time Condition Switch',
      personalconf: 'Personal Conference',
      agentlogin: 'Pause/Unpause Queues Agents',
      moh: 'Music On Hold',
      adhoc: 'Adhoc',
      unadhoc: 'Unadhoc',
      qoffall: 'Pause/Unpause All Queues Agents',
      toggle: 'Swicth Toggle Dest',
      dnd: 'Do Not Disturb',
      forward: 'Forward',
      followme: 'Follow Me',
      intercom: 'Intercom',
      silenticom: 'Silent Intercom',
      call_blind_transfer: 'Blind Transfer',
      directed_call_pickup: 'Directed Call Pickup',
      on_demand_call_recording: 'Call Recording',
      tcswitch: 'Time Condition Switch',
      blacklist_number_add: 'Add a number to the blacklist',
      blacklist_number_remove: 'Remove a number from the blacklist',
      blacklist_number_add_last_caller: 'Add last caller number to the blacklist'
    },
    loading: 'Loading contacts. Please, wait...',
    total: 'Total contacts: {n}',
    searchPlaceholder: 'Search Contacts',
    createSuccess: 'Contact created successfully',
    updateSuccess: 'Contact updated successfully',
    deleteSuccess: 'Contact deleted successfully',
    footerProps: {
      pageText: '{0}-{1} of {2} contacts',
      total: 'Contacts per page'
    },
    tip: {
      noData: 'No contacts found'
    },
    tagForm: {
      name: 'Name'
    },
    tagDeleteForm: {
      confirmation: 'Are you sur you want to delete the tag',
      // pluralization support, use $tc instead of $t
      inUseMessage:
        'No contact is using this tag. | {inUseCount} contact is using this tag. | {inUseCount} contacts are using this tag.'
    },
    detailsDialog: {
      title: 'Contact',
      address: 'Address',
      openMap: 'See on Maps'
    },
    deleteForm: {
      confirmation: 'Are you sur you want to delete the shared contact',
      confirmationPersonal:
        'Are you sur you want to delete the personal contact'
    },
    formValidation: {
      required: 'This field is required',
      lettersOnly: 'This field must be letters only',
      numericOnly: 'This field must be numeric only',
      minimumChar: 'This field must be at least {min} characters',
      minimumDigit: 'This field must be at least {min} digits',
      validEmail: 'This field must be a valid email'
    },
    form: {
      addressTypes: {
        home: 'Home',
        work: 'Work',
        school: 'School',
        other: 'Other'
      }
    },
    errors: {
      load: 'Error while loading contact'
    },
    importForm: {
      title: 'Import',
      fileField: 'Pick a contact CSV file',
      notice:
        '<p> You want to import news contacts ? </p> <ul><li>Export your existing contacts so have a valid CSV architecture to work on.</li><li>ID field should remain empty if you want to create a contact.</li><li>As a reminder, in a valid CSV, every fields are comma separated</li></ul><p> You want to update existing contacts?</p><ul><li>Export your contacts and edit them.</li><li>As a reminder, in a valid CSV, every fields are comma separated</li></ul>'
    },
    columns: {
      name: 'Name',
      email: 'Email',
      emails: 'Emails',
      firstName: 'First Name',
      lastName: 'Last Name',
      company: 'Company',
      jobTitle: 'Job Title',
      addressType: 'Address Type',
      street: 'Address Line',
      city: 'City',
      state: 'State / Province / Region',
      postalCode: 'ZIP / Postal Code',
      country: 'Country',
      tags: 'Shared Tags',
      personalTags: 'Personal Tags',
      image: 'Profile Picture',
      phoneNumber: 'Phone Number',
      phoneNumbers: 'Phone Numbers',
      useAsCallerid: 'Use as Caller ID',
      isPersonal: 'This is a personal contact',
      cellRenderer: {
        boolean: {
          true: 'Yes',
          false: 'No'
        }
      }
    },
    btn: {
      newContact: 'Create contact',
      sharedContacts: 'Shared Contacts',
      personalContacts: 'Personal Contacts',
      export: 'Export',
      import: 'Import',
      print: 'Print',
      createTag: 'Create tag',
      createPersonalTag: 'Create personal tag',
      create: 'Create',
      update: 'Update',
      delete: 'Delete',
      cancel: 'Cancel',
      bulk: '{count} selected'
    },
    confirmBulkDelete: {
      title: 'Delete contacts',
      message: 'No contact to delete | Are you sure you want to delete this contact? | Are you sure you want to delete those {count} contacts?'
    },
    notify: {
      createdOk: 'Contact created successfully',
      updatedOk: 'Contact updated successfully',
      deletedOk: 'Contact deleted successfully',
      bulkDelOk: '{count} contacts successfully deleted'
    }
  },
  // cdrs page
  cdrs: {
    menuTitle: 'Call history',
    loading: 'Loading records. Please, wait...',
    total: 'Total records: {n}',
    footerProps: {
      pageText: '{0}-{1} of {2} calls',
      total: 'Calls per page'
    },
    columns: {
      from: 'From',
      to: 'To',
      duration: 'Duration'
    },
    err: {
      load: 'Failed to load CDRs from API',
      recNotFound: 'Recording not found'
    },
    tip: {
      incoming: 'Incoming call.',
      outgoing: 'Outgoing call.',
      noData: 'No calls found on this time period',
      failed: 'Call failed.'
    },
    btn: {
      callback: 'Callback',
      playrec: 'Play recording',
      download: 'Download recording',
      bulk: '{count} selected',
      close: 'Close'
    },
    filter: {
      extensions: 'Extensions',
      allExtensions: 'All',
      startDate: 'Start date',
      endDate: 'End date'
    },
    numLabel: {
      vm: 'Voicemail',
      conf: 'Conference',
      myconf: 'Personal Conference',
      park: 'Parking lot',
      parkPickup: 'Parking pickup',
      queue: 'Queue',
      jitsi: 'Jitsi Conference'
    },
    recordings_download: {
      title: 'Call recordings download',
      success: 'We are preparing your recordings archive. You will be notified by email when it is ready for download.',
      error: 'An error occured while preparing your recordings archive.'
    }
  },
  // settings page
  settings: {
    menuTitle: 'Settings',
    callWaiting: 'Call Waiting',
    icomDesk: 'Intercom Desk Phone Allow',
    icomCallpanel: 'Intercom Allow for CallPanel',
    icomAnywhere: 'Intercom Allow for Anywhere',
    dnd: 'Do Not Disturb',
    showMissedCalls: 'Show Missed Calls',
    errors: {
      missingPermissions: 'Missing Permissions'
    },
    drawer: {
      phoneStatus: 'Phone Status',
      devices: 'Media Devices',
      account: 'Account',
      softphone: 'Clearly Anywhere',
      emergency: 'Emergency',
      notifications: 'Notifications',
      clickToDial: 'Click to dial',
      callScreenPop: 'Call Screen Pop-up',
      stunServers: 'STUN Servers'
    },
    notifications: {
      title: 'Notifications',
      enabled: 'Enable',
      timeout: 'Timeout'
    },
    notify: {
      dndOn: 'Do Not Disturb enabled',
      dndOff: 'Do Not Disturb disabled',
      smcOn: 'Show Missed Calls enabled',
      smcOff: 'Show Missed Calls disabled',
      cwOn: 'Call waiting enabled',
      cwOff: 'Call waiting disabled',
      icomOn: 'Intercom enabled for {icom}',
      icomOff: 'Intercom disabled for {icom}',
      fwdSaved: 'Call forward settings saved successfully',
      fwdOff: 'Call forward disabled',
      fmeSaved: 'Follow-me settings saved successfully',
      fmeOff: 'Follow-me disabled',
      ctdSaved: 'Click-to-dial settings saved successfully',
      screenPopSaved: 'Screen pop settings saved successfully',
      stunServersSaved: 'STUN servers settings saved successfully'
    },
    fme: {
      title: 'Follow Me',
      ringStrategy: {
        label: 'Ring Strategy',
        strategies: {
          ringall: 'Ring All Extensions',
          hunt: 'Ring Extensions Sequentially',
          memoryhunt: 'Ring Extensions Sequentially with Memory'
        }
      },
      save: 'Save changes',
      prefix: 'CLID Prefix',
      confirm: 'Use confirmation',
      markanswered: 'Mark Answered Elsewhere',
      ringFirst: 'Ring first timeout (sec)',
      ringAll: 'Ring all numbers timeout (sec)',
      num: 'Number or extension',
      addNumBtn: 'Add',
      noData: 'No follow me numbers set',
      errInvalid: 'Invalid number',
      errMax: 'Maximum 5 followme numbers can be added',
      errExists: 'Number {num} is already added',
      errTimeoutTooBig: '{timeout}s is too big. The maximum allowed is 100s.',
      errTimeoutTooSmall: '{timeout}s is too small. The minimum allowed is 0s.',
      showMore: 'Show advanced settings',
      prefixPlaceholder: 'Example: Work',
      seconds: 'sec',
      labels: {
        numbers: 'Follow Me Destinations',
        cid: 'CallerID',
        timeouts: 'Timeouts'
      },
      clid: {
        label: 'Caller ID setup for external numbers',
        externCIDName: 'CallerID Name',
        externCIDNum: 'CallerID Number',
        useUser: 'Use your external CID',
        useInbound: 'Use inbound caller CID',
        useCustom: 'Use a custom CID'
      },
      tc: { // time conditions
        label: 'Time condition',
        none: 'None'
      }
    },
    blacklist: {
      title: 'Blacklist Numbers',
      name: 'Name of the blacklisted number',
      num: 'Blacklisted number',
      hint: 'Allowed numbers',
      save: 'Save Changes',
      errInvalid: 'Invalid number',
      errExists: 'Number {num} is already added',
      errRequired: 'This field is required',
      addSuccess: 'Number has been added to the blacklist',
      addFailed: 'Failed to add number to the blacklist'
    },
    fwd: {
      title: 'Call Forward',
      num: 'Forward number',
      save: 'Save changes',
      hint: 'Allowed numbers, asterisk (*) or pound (#)',
      errRequired: 'Number required',
      errInvalid:
        'Invalid number. Allowed input characters are digits, asterisk (*) and pound (#)'
    },
    media: {
      title: 'Media Devices Settings',
      labelInput: 'Input device',
      labelOutput: 'Output device',
      labelRingDev: 'Incoming call sounds device',
      labelRingtone: 'Incoming call sound',
      labelRingingVolume: 'Ringing volume',
      ringBtnTooltip: 'Play selected incoming call sound',
      testBtnTooltip: 'Play ring sound to test selected output device',
      enableRingDev: 'Custom device for incoming call sounds',
      notSupported: 'Your browser does not support media device selection. ' +
        'This option is currently supported by Google Chrome, Microsoft Edge, and Opera browsers. ' +
        'Mozilla Firefox browser has experimental support for this which you can enable by setting ' +
        '"media.setsinkid.enabled" to enabled. For further assistance please contact support.',
      ringingUpdateFail: 'Failed to update ringing tone: {err}',
      ringtoneSaved: 'Ringtone successfully saved'
    },
    emergency: {
      title: 'Emergency Settings',
      profile: 'Emergency Call-Back Profile',
      location: 'Dispatchable location',
      default: 'Use system default settings',
      noData:
        'No Editable Emergency Settings. Please talk to your administrator',
      permLimit: {
        title: 'Some permissions are missing',
        profRd: 'profiles read',
        profWr: 'profiles write',
        locRd: 'locations read',
        locWr: 'locations write'
      },
      callerName: 'Caller Name',
      callerNum: 'Callback Number',
      callerIDPrefix: 'Caller ID Prefix',
      callbackNum: 'Callback Number',
      locName: 'Name',
      address: 'Address'
    },
    clearlyaw: {
      title: 'Download the Clearly Anywhere app',
      tooltip: {
        googlePlay: 'Get on Google Play',
        appleStore: 'Download on the App Store',
        appleApp: 'Download MacOS Desktop application',
        winApp: 'Download Windows Desktop application',
        qrcode: 'Get ready with a QR code',
        help: 'More information about Clearly Anywhere'
      },
      qrdlg: {
        title: 'QR Code to connect Clearly Anywhere',
        credInfo: 'Or get ready with your web credentials',
        email: 'Email',
        passwd: 'Password',
        pwdText: 'Your login password',
        realm: 'Realm',
        reset: 'Reset',
        btnClose: 'Close',
        btnByEmail: 'Get ready with an email'
      },
      credsPostOK: 'Email was successfully sent',
      credsPostFail: 'Failed to send email: ',
      credsResetOK: 'QR Code reset successfully',
      credsResetFail: 'Failed to reset QR Code: ',
      qrhelp: 'Scan this QR code from the Clearly Anywhere ' +
        'application in order to get ready',
      failed: 'Failed to get Clearly Anywhere data'
    },
    toggle: {
      title: 'Toggle destinations',
      notifySuccess: 'Destination for "{name}" is set to "{dest}"'
    },
    user: {
      title: 'Personal user settings',
      updateOk: 'Successfully updated user',
      selectBox: 'Select user account',
      otp: {
        title: 'One-time password (OTP) settings',
        updateOk: 'Successfully updated OTP settings',
        updating: 'Updating...',
        enable: 'OTP Enabled (2FA)',
        method: 'OTP Method',
        sms: 'SMS',
        phoneNum: 'Phone number',
        email: 'Email',
        emailAddr: 'Email address',
        qrcode: 'Authenticator',
        qrcHelp: 'Scan this QR code with your app authenticator',
        errUpdate: 'Failed update user OTP settings: ',
        errPermissions:
          'User does not have write permissions to update settigs',
        errSMS: 'Valid phone number required',
        errEmail: 'Valid email address required'
      },
      lbl: {
        username: 'Username',
        email: 'Email',
        pwdNew: 'New password',
        pwdConfirm: 'Confirm password'
      },
      btn: {
        update: 'Update',
        cancel: 'Cancel',
        save: 'Save changes',
        otp: 'OTP'
      },
      err: {
        required: 'Required value',
        pwdMatch: 'Password confirm does not match password value',
        update: 'Failed update user settings: '
      }
    },
    clickToDial: {
      title: 'Click-to-dial settings',
      labelDestination: 'Destination',
      destinationTypes: {
        softphoneShow: 'Show softphone',
        callPanelDial: 'Dial number via Call Panel',
        dialAfterOriginate: 'Call my devices and dial after answer'
      },
      installCallHandler: 'Install'
    },
    dids: {
      title: 'DIDs',
      table: {
        noData: 'No DIDs available for this user',
        name: 'Name',
        did: 'Number',
        destType: 'Dest. Type',
        destName: 'Dest. Name',
        smsCapable: 'SMS'
      },
      default: 'default'
    },
    screenPop: {
      title: 'Screen pop settings',
      type: 'Type',
      typeList: {
        none: 'None',
        url: 'URL'
      },
      trigger: 'Trigger',
      triggerList: {
        ringing: 'Ringing',
        answered: 'Answered'
      },
      url: 'URL',
      save: 'Save changes',
      help: 'URL template variables:',
      variable: {
        callerid_number: 'Caller ID number',
        callerid_name: 'Caller ID name',
        extension: 'Called extension number',
        extension_name: 'Called extension name',
        did: 'DID',
        wait_sec: 'Waiting time in seconds'
      }
    },
    stunServers: {
      title: 'STUN Servers',
      label: 'List of STUN servers, comma separated',
      caption1: 'Example: stun:example.org, stuns:example.org, stun:example.org:8000',
      caption2: 'Leave empty to use the default STUN server: stun:stun.l.google.com:19302',
      caption3: 'Requires a reload of the Call Panel app to take effect.',
      invalidFormat: 'Invalid format',
      save: 'Save + Reload app'
    }
  },
  help: {
    notifications: {
      enable: 'Enable or disable notifications which includes incoming call notifications and incoming message notifications. If this setting is enabled and you allowed notifications in your browser, then you will get system wide notifications allowing you to get notified even when the call panel is minimized. If this setting is enabled but browser notifications is not, you will have notifications inside call panel only.',
      timeout: 'Delay in seconds during which the notification will remain visible'
    },
    vm: {
      email: 'Email address for voicemail notifications.',
      pager: 'Pager/mobile email address for shortened voicemail notifications.',
      pin: 'Pin Used to Login to Voicemail. This pin can only contain numbers.',
      attach: 'Include the voicemail message as an email attachment when sending notifications.',
      delvm:
        'If enabled the message will be deleted from the Voicemail box (after having ' +
        'been emailed). Provides functionality that allows a user to receive their ' +
        'Voicemail via email alone, rather than having the Voicemail able to be ' +
        'retrieved from the Web interface or the Extension handset. CAUTION: MUST ' +
        'HAVE attach Voicemail to email SET TO YES OTHERWISE YOUR MESSAGES WILL BE ' +
        'LOST FOREVER.',
      playcid:
        "Read back caller's telephone number prior to playing the incoming message," +
        ' and just after announcing the date and time the message was left.',
      envelope:
        'Play the date and time stamp of when the voicemail was left anytime you ' +
        'listen to the voicemail.',
      archive:
        'When greeting is archived it is possible to restore it later and replace any ' +
        'existing greeting, busy or unavailable messages',
      skipInstruct:
        'By default when someone gets to your voicemail be instruction message is ' +
        'played: "Please, leave your message after the tone, when done hangup or press the ' +
        'pound key". This option will disable instructions playing for your voicemail box',
      transcript: 'Voice messages will be automatically transcribed to text.',
      translate: 'When transcription is enabled, message text will be translated to your language when needed.',
      greeting: {
        name:
          'A recording of your name, used mainly for things like the ' +
          'Company Directory and other modules.',
        busy:
          'Greeting used when you are on another call or choose to decline a call.',
        unavail:
          'Greeting used when a call is not answered.',
        temp:
          'A greeting which can be used to replace both busy and unavailable greetings temporarily. ' +
          'Commonly used for vacations and short-term notices.'
      },
      xfer:
        'Search for transfer destination from users list. ' +
        'Start typing name or extension of a user, then select to transfer a message.'
    },
    confr: {
      inv:
        'Invite a member to the conference. Enter the number you wish to invite to the conference ' +
        'and click "Enter" of button "Invite". System will call to the number and when call is answered ' +
        'the call will join the conference. No PIN authentication is prompted.'
    },
    bargein: {
      monitor:
        'Allows the person doing the Barge to come into the call and listen to both ' +
        'legs of the call but not talk and neither side of the call is aware the barger ' +
        'has barged in',
      full:
        'Allows the person doing the Barge to come into the call and listen to both legs ' +
        'of the call. Connect user will be muted and can unmute themselves and can take ' +
        'part of the call. A tone would be played informing the callers that someone barged in',
      whisper:
        'Allows the person doing the Barge to come into the call and listen to both legs but ' +
        'talk only to one particular caller. Only selected leg of the call will hear the tone ' +
        'informing them someone has barged in'
    },
    pcs: {
      countSay:
        'Announce the current number of participants when a user joins the conference.',
      moh: 'Hold music is played when the conference has only one participant.',
      waitAdmin:
        'Wait for the arrival of the conference administrator (host) to start the ' +
        'conference. If "Music on hold" is enabled, music will be played while waiting for the admin.',
      joinSay: 'Announce when a user joins or leaves the conference.',
      openMenu: 'Listen to the conference options by pressing the "*" key.',
      listenOnly:
        'Participants that connect with the User PIN cannot talk in the conference.'
    },
    callfwd: 'Redirect all calls to the given number.',
    dnd:
      'Toggle on or off Server side DND.  When is DND mode all calls will go to the busy destination of ' +
      'the user which by default is their voicemail box. ',
    callwait:
      'If on a active call and an additional call comes in that call will show up and you will have the ' +
      'ability to answer the call while the current call is put on hold.',
    icomDesk:
      'If a intercom call comes to your Desk Phone with this enabled, the Phone will auto answer. If you ' +
      'are on a active call when the Intercom comes in the call will be treated as a inbound ringing call ' +
      'instead of auto answer on most SIP Desk Phones.',
    icomCallpanel:
      'If a intercom call comes to your CallPanel Softphone with this enabled, the CallPanel Softphone will ' +
      'auto answer. If you are on a active call when the Intercom comes in the call will be treated as a inbound ' +
      'ringing call instead of auto answer.',
    icomAnywhere:
      'If a intercom call comes to your Clearly Anywhere Softphone with this enabled, the Clearly Anywhere ' +
      'Softphone will auto answer. If you are on a active call when the Intercom comes in the call will be ' +
      'treated as a inbound ringing call instead of auto answer.',
    intercom:
      'When enabled the phone will automatically answer intercom calls.',
    showMissedCalls: 'When enabled, displays missed calls count in the softphone and user toolbar.',
    media: 'Setup input and output devices for web calls, recording etc.',
    clearlyaw:
      'From this page you can connect to your Clearly Anywhere softphone. ' +
      'With Clearly Anywhere, users can communicate free of charge and directly ' +
      'dial the extension of another user. For some users, this completely ' +
      'replaces the desk phone.',
    mediaRingDev:
      'When set the device will be used for incoming calls ringing.',
    followme: {
      enable:
        'Enables incoming phone calls to be received at different locations, ' +
        'on different phones.',
      confirm:
        "Enable this if you're calling external numbers that need confirmation " +
        '- eg, a mobile phone may go to voicemail which will pick up the call. ' +
        'Enabling this requires the remote side push 1 on their phone before the ' +
        'call is put through.',
      markanswered:
        'Should calls indicate answered elsewhere when a user answers.',
      prefix:
        'Set a short (up to 10 characters) prefix text that will be prepended to ' +
        'Caller ID name.',
      toutFirst: 'Set up a delay before the Follow Me device starts ringing.',
      toutAll: 'The maximum time that the followme device will ring.',
      num: 'Add number to ring. May be local extension or external DID.',
      cid: 'This option is only applied to the follow-me external numbers. ' +
        'If it is incoming call from external number and follow-me is set to ' +
        'external number (like cell phone) then here you can set Caller ID you ' +
        'will see on your external, destination device. It can be caller CID or ' +
        'your company external caller ID or your custom external caller ID.',
      externCIDName: 'When using a custom caller ID, you set your own caller ID for your followme. This is the callerID name.',
      externCIDNum: 'When using a custom caller ID, you set your own caller ID for your followme. This is the callerID number.',
      timeCond: 'You can set time condition with your follow-me. When it is set then ' +
        'call to follow-me numbers will be made only if call time match time ' +
        'condition. Time conditions are configured by systemc administrators. ' +
        'Please, contact your technical support for more details.',
      strategies: '<b>Ring All Extensions</b>: all extensions in the group ring simultaneously until one answers. If no one answers before the dial timeout expires, the call is sent to the failure destination.<br><b>Ring Extensions Sequentially</b>: the extensions ring alternately, with each ringing for the duration of the dial timeout. If none of the extensions answer, the call is sent to the failure destination. <br><b>Ring Extensions Sequentially with Memory</b>: Rings extensions sequentially, retaining previous extensions in the ringing process until the call is answered.'
    },
    blacklist: 'Manage numbers added to the blacklist.',
    queues: {
      pauseCause: 'Select agent pause/unpause cause from the list. ' +
        'You can start typing text to search cause. ' +
        'The pause cause will be available in queues statistics.'
    },
    callRec:
      'Download call recording. If you cancel download the recording is lost.',
    emergency: {
      profile:
        'The Emergency Call-Back Profile provides the Company Name and a ' +
        'Call Back Number when a 911 call is placed.',
      location: 'The dispatchable location for your device'
    },
    toggle:
      'Toggle destination has 2 destinations, you can switch from one to another ' +
      'by dialing "*44*ID" (you can find ID in this grid) or from this page by clicking ' +
      'destination. You can use it as a destination from your favorite feature (digital ' +
      'receiptionists, destination aliases, time conditions ...).',
    userAccSelect: "You have permission to access multiple users' accounts " +
      'and can change options if they are also allowed by permissions. When ' +
      'not allowed it will be greyed out and disabled.',
    clickToDial: 'How to handle click-to-dial call requests.'
  },
  perms: {
    nochange: 'No change permissions',
    readOnly: 'Read Only',
    noPermission: 'No read or write permission'
  }
}
